import React, { useEffect, useContext, useRef } from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import { useAuthenticator } from '@aws-amplify/ui-react';
import UserContext from '../contexts/UserContext';
import storageService from '../services/storage.service';

const PrivateRoute = ({ component: C, props: cProps, ...rest }) => {
  const { authStatus } = useAuthenticator((ctx) => [ctx.authStatus]);
  const {
    authDrawerOpen,
    setAuthDrawerOpen,
  } = useContext(UserContext);

  const attemptedOnceRef = useRef(false);

  // const { path } = { ...rest };

  useEffect(() => {
    // do nothing while Amplify is restoring the session
    if (authStatus === 'configuring') return;

    if (authStatus === 'unauthenticated') {
      if (!attemptedOnceRef.current) {
        const path = window.location.pathname ?? rest.path ?? '/';
        storageService.setItem('redirectAfterAuthentication', path);
        setAuthDrawerOpen(true);
        attemptedOnceRef.current = true;
      }
    } else if (authStatus === 'authenticated') {
      // close drawer on auth, reset the attempt flag
      if (authDrawerOpen) setAuthDrawerOpen(false);
      attemptedOnceRef.current = false;
    }
  }, [authStatus, authDrawerOpen, rest.path, setAuthDrawerOpen]);

  return (
    <Route
      {...rest}
      render={(props) => (authStatus === 'authenticated') && (
        <C {...props} {...cProps} match={rest.computedMatch} />
      )}
    />
  );
};

PrivateRoute.propTypes = {
  component: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.func,
  ]).isRequired,
  props: PropTypes.object.isRequired,
};

export default PrivateRoute;
